module.exports = __webpack_public_path__ + "img/花草_02.566cf3fc.png";